<div class="unsubscribe-feature">
  <img src="assets/svg/access_denied.svg" alt="access denied" />
  <div class="head">Oops Sorry</div>
  <div class="subhead">
    You are not subscribed to this feature currently
  </div>
  <div class="visit" (click)="redirectToHomePage()">Visit plans</div>
</div>
